import type { TokenDefinition, } from "@bracket/chainography";
import { getCollateralInfo, } from "@bracket/contractor-next/brktETH";
import { wagmiConfig as config, } from "@wagmiconfig";
import { isNativeToken, } from "./isNativeToken";



/**
 * Gets the maximum amount of collateral token available in the treasury
 * @param {Object} params - The parameters object
 * @param {TokenDefinition} params.token - The token to get the maximum collateral for
 * @returns {Promise<bigint>} The maximum amount of collateral that can be deposited
 */
export const getCollateralMaximum = async ({
	token,
}: { token: TokenDefinition; }): Promise<bigint> => {
	try {
		if(isNativeToken(token))
			return BigInt(999 * 1e18);
		const info = await getCollateralInfo({ token, config, });
		if(info?.totalDeposit) {
			return info.totalDeposit;
		}
		return BigInt(0);
	}
	catch(err) {
		console.error(err);
		return BigInt(0);
	}
}
